import { defineMessages } from 'react-intl'

import { STATUS } from './constants'

export const statusMessages = defineMessages({
  [STATUS.STARTED]: {
    id: 'dictionary.started',
    defaultMessage: 'Started'
  },
  [STATUS.CANCELLED]: {
    id: 'dictionary.cancelled',
    defaultMessage: 'Cancelled'
  },
  [STATUS.COMPLETED]: {
    id: 'dictionary.completed',
    defaultMessage: 'Completed'
  },
  [STATUS.SCHEDULED]: {
    id: 'dictionary.scheduled',
    defaultMessage: 'Scheduled'
  }
})
